import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import Particle from "../Particle";
import Github from "./Github";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/about.png";
import Toolstack from "./Toolstack";
import AnimatedSection from "../AnimatedSection";

function About() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row className="align-items-center" style={{ padding: "10px" }}>
          <Col md={7} style={{ paddingTop: "30px", paddingBottom: "50px" }}>
            <AnimatedSection>
              <h1 className="section-title" style={{ textAlign: "left" }}>
                Know Who <span className="purple">I'M</span>
              </h1>
              <Aboutcard />
            </AnimatedSection>
          </Col>
          <Col md={5} style={{ paddingBottom: "50px" }} className="about-img">
            <AnimatedSection direction="right" delay={0.2}>
              <motion.img
                src={laptopImg}
                alt="about"
                className="img-fluid"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7 }}
              />
            </AnimatedSection>
          </Col>
        </Row>

        <AnimatedSection>
          <h1 className="project-heading">
            Professional <span className="purple">Skillset</span>
          </h1>
        </AnimatedSection>
        <Techstack />

        <AnimatedSection>
          <h1 className="project-heading">
            <span className="purple">Tools</span> I Use
          </h1>
        </AnimatedSection>
        <Toolstack />

        <Github />
      </Container>
    </Container>
  );
}

export default About;
